<template>
  <div id="comwindow">
    com window
  </div>
</template>
